import LoginCard from '../../components/LoginCard/LoginCard';
import styles from './LandingPage.module.css';

const LandingPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.brand}>
        {/* <span className={styles.horizontal}>klaes</span> */}
        {/* <span className={styles.vertical}>ae</span> */}
      </div>
      <div className={styles.center}>
        <LoginCard />
      </div>
    </div>
  );
};

export default LandingPage;